"use client";

import {HTML5Backend} from "react-dnd-html5-backend";
import dynamic from "next/dynamic";
import {PropsWithChildren} from "react";
import {useStores} from "../../stores/useStores";

const DndProvider = dynamic(() => import("react-dnd").then(module => module.DndProvider));

export function DragAndDropProvider(props: PropsWithChildren<{}>) {
    const {userStore} = useStores();

    if (userStore.editor) {
        // @ts-ignore
        return <DndProvider backend={HTML5Backend}>
            {props.children}
        </DndProvider>
    } else {
        return props.children;
    }
}